export default function objectToQuerystring(obj) {
    return Object.keys(obj).reduce((str, key, index) => {
        const delimiter = index === 0 ? '' : '&';
        const newKey = encodeURIComponent(key);
        const value = encodeURIComponent(obj[key]);

        return `${str}${delimiter}${newKey}=${value}`;
    }, '?');
}
